import React from 'react';
import CrossLoader from '../CrossLoader/CrossLoader';
import './DataLoader.css';

function DataLoader({message, loaderSize}) {
    return (
        <div className='data-loader'>
            <div className='data-loader_spinner'>
                <CrossLoader size={loaderSize || 200}/>
            </div>
            <p className='data-loader_message'>{message}</p>
        </div>
    )
}

export default DataLoader;